var API_DOMAIN = "https://demogoldfinance.zentexus.com/api";
//var API_DOMAIN = "http://localhost/abinayafinance25/api";

export default API_DOMAIN;
